import {
  AddContactsPeopleTableKeys,
  CHECKBOX_COLUMNS,
  IGNORE_COLUMNS,
  REQUIRED_COLUMNS,
  TABLE_COLUMNS,
} from './components/ManageContactTableCells/data';

export const checkIfColumnIsValid = (column: string) =>
  TABLE_COLUMNS.includes(column as AddContactsPeopleTableKeys);

export const checkIfColumnIsCheckbox = (column: string) =>
  CHECKBOX_COLUMNS.includes(column);

export const checkIfCanProcessColumn = (column: string) =>
  checkIfColumnIsValid(column) && !checkIfColumnIsCheckbox(column);

export const checkIsNotIgnoreColumn = (column: string) =>
  !IGNORE_COLUMNS.includes(column);

export const checkHasEveryRequiredColumn = (columns: string[]) =>
  REQUIRED_COLUMNS.every((col) => columns.includes(col));
